import './mail-allocated.ajscss';

import { EpticaDeprecatedService } from '@agent/core/channel-digit/mail/eptica/eptica-deprecated.service';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions } from 'angular';
import { first, map, merge, of, switchMap, throwIfEmpty } from 'rxjs';

import { BookingFacade, EpticaService, isNotNullOrUndefined, RefuseReason } from '@contact/upgrade';

import templateUrl from './mail-allocated.template.html';

class MailAllocatedCtrl implements IComponentController {
  responseId: string;

  constructor(
    private readonly contactFacade: BookingFacade,
    private readonly epticaDeprecatedService: EpticaDeprecatedService,
    private readonly epticaService: EpticaService
  ) {}

  $onInit() {
    const assignRequestIfNoResponsible = (onlyDifferentFromAccountResponsible = false) =>
      switchMap((requestId: string) =>
        this.epticaService.getRequest(requestId).pipe(
          isNotNullOrUndefined(),
          throwIfEmpty(),
          switchMap(request => {
            if (
              !request.accountResponsible ||
              (!onlyDifferentFromAccountResponsible && request.accountResponsible.id !== this.epticaDeprecatedService.getMailAccountId())
            ) {
              return this.epticaDeprecatedService.assignRequest(requestId);
            }
            return of({});
          })
        )
      );

    const selected$ = this.contactFacade.selected$;
    // if not contact or no eptica request id, we refuse contact
    // case or request should be nor process
    const invalid$ = selected$.pipe(first(contact => !contact || !contact.epticaRequestId));
    // case or request should be process
    const assignable$ = selected$.pipe(
      isNotNullOrUndefined(),
      first(contact => !!contact.epticaRequestId && !contact.epticaReceivedAskForHelpRequest && !contact.epticaApprovalRequest),
      map(contact => `${contact.epticaRequestId}`),
      assignRequestIfNoResponsible()
    );

    const receivedAskForHelp$ = selected$.pipe(
      isNotNullOrUndefined(),
      first(contact => contact.epticaReceivedAskForHelpRequest),
      map(contact => `${contact.epticaRequestId}`),
      assignRequestIfNoResponsible(true)
    );

    const receivedApproval$ = selected$.pipe(
      isNotNullOrUndefined(),
      first(contact => contact.epticaApprovalRequest)
    );
    // assign request
    merge(assignable$, receivedAskForHelp$, receivedApproval$)
      .pipe(ng1Destroy(this))
      .subscribe(() => this.contactFacade.process(this.responseId));
    // refuse request
    invalid$.pipe(ng1Destroy(this)).subscribe(() => this.contactFacade.refuse(this.responseId, RefuseReason.TECH_FAILURE));
  }
}

export class MailAllocated implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = ['contactFacade', 'epticaDeprecatedService', 'epticaService', MailAllocatedCtrl];
}

export default 'contactContactMailAllocated';
